<div class="profile-selection-container">
  @if (profiles?.relatedProfiles?.length >= 1 && !vet && activeUsers.length > 0) {
    <app-info-box
      [title]="('steps.profileSelection.title' | translate) + typeAppointment.toLowerCase() + '?'"
      [description]="('steps.profileSelection.description' | translate) + typeAppointment.toLowerCase()"
    ></app-info-box>
    <div class="selectors-container">
      <nz-radio-group [formControl]="profileSelected">
        <div class="selector">
          <label nz-radio [nzValue]="profiles">{{ profiles?.['fullName'] }}</label>
        </div>
        @for (profile of profiles.relatedProfiles; track profile) {
          @if (profile.isChangeProfileEnabled) {
            <div class="selector">
              <label nz-radio [nzValue]="profile">{{ profile?.['fullName'] }}</label>
            </div>
          }
        }
        @if (isUserManagementAble) {
          <div class="selector last-element" (click)="createProfile()">
            <p>{{ 'steps.profileSelection.createProfile' | translate }}</p>
            <img src="/public/assets/images/plus-circle.svg" />
          </div>
        }
      </nz-radio-group>
    </div>
  }
  @if (vet) {
    <app-info-box
      [title]="('steps.profileSelection.choose' | translate) + typeAppointment.toLowerCase()"
      description="{{ 'steps.profileSelection.this_choice' | translate }}"
    ></app-info-box>
    <div class="selectors-container">
      <nz-radio-group [formControl]="vetTypeSelected">
        <div [ngClass]="modeSelection ? 'mode-selection' : ''" class="selector">
          <label nz-radio [nzValue]="'Telefonica'">{{ 'steps.profileSelection.telephonic' | translate }}</label>
        </div>
        <div [ngClass]="modeSelection ? 'mode-selection' : ''" class="selector">
          <label nz-radio [nzValue]="'Video'">{{ 'steps.profileSelection.video' | translate }}</label>
        </div>
      </nz-radio-group>
    </div>
  }
  @if ((profileSelected.value || profiles?.relatedProfiles?.length === 0) && !vet) {
    <app-info-box
      [title]="('steps.profileSelection.title' | translate) + typeAppointment.toLowerCase() + '?'"
      [description]="('steps.profileSelection.description' | translate) + typeAppointment.toLowerCase()"
    ></app-info-box>
    <div class="data-container">
      <h3>{{ 'steps.profileSelection.dataProfile' | translate }}</h3>
      <nz-divider></nz-divider>
      <div class="info-container">
        <div>
          <p class="title">
            {{ 'steps.profileSelection.profile' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.fullName ? profileSelected.value.fullName : '-' }}</p>
        </div>
        <div>
          <p class="title">
            {{ 'steps.profileSelection.telephone' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.phone ? profileSelected.value.phone : '-' }}</p>
        </div>
        <div>
          <p class="title">
            {{ 'steps.profileSelection.email' | translate }}
          </p>
          <p class="value">{{ profileSelected.value.email ? profileSelected.value.email : '-' }}</p>
        </div>
      </div>
      <div class="subtitle-container">
        @if (profileSelected.value.fullName && profileSelected.value.phone && profileSelected.value.email) {
          <span nz-icon nzType="info-circle" nzTheme="fill"></span>
          <p class="inner-container">
            {{ 'steps.profileSelection.dataVerify' | translate }} <a (click)="switchProfile(profileSelected)">{{ 'steps.profileSelection.goToProfile' | translate }}</a>
          </p>
        } @else {
          <span nz-icon nzType="close-circle" nzTheme="fill"></span>
          <p class="inner-container">
            {{ 'steps.profileSelection.dataVerifyError' | translate }}<a (click)="switchProfile(profileSelected)">{{ 'steps.profileSelection.goToProfile' | translate }}</a>
          </p>
        }
      </div>
    </div>
  }
</div>
